<template>
    <el-skeleton :loading="loading" animated :throttle="500">
        <template slot="template">
            <div class="goods">
                <el-skeleton-item variant="image" style="width: 300px; height: 180px;" />
                <div class="detail">
                    <el-skeleton-item variant="h2" class="name" style="width:80%" />
                    <div class="info">
                        <el-skeleton-item variant="text" style="width: 30%;margin-bottom: 55px;" />
                    </div>
                    <el-skeleton-item variant="h2" style="width: 90%;margin-bottom: 20px;" />
                    <el-skeleton-item variant="h2" style="width: 90%;" />
                </div>
                <div class="extra">
                    <el-skeleton-item variant="image" style="width: 104px; height: 36px;margin-bottom: 10px;" />
                    <div><el-skeleton-item variant="div" style="margin-bottom: 60px;" /></div>
                    <div><el-skeleton-item variant="div" style="height: 20px;" /></div>
                    <div><el-skeleton-item variant="div" style="width:140px;height: 40px;" /></div>
                </div>
            </div>
        </template>
        <template>
            <div class="goods" v-if="info">
                <div class="relative poster-div">
                    <a :href="href()" target="_blank">
                        <el-image class="poster !block" fit="cover" :src="info.image"></el-image>
                    </a>
                    <div v-if="loggedIn">
                        <el-image class="collect-icon" v-if="isFavorite" fit="cover"
                            :src="require('@/assets/img/resource/collected-icon.png')" @click="onToggleFavorite" />
                        <el-image class="collect-icon" v-else fit="cover"
                            :src="require('@/assets/img/resource/collect-icon.png')" @click="onToggleFavorite" />
                    </div>
                </div>
                <div class="detail">
                    <h2 class="name mb-2.5">
                      <el-tooltip placement="bottom-start" popper-class="popper-class-tooltip" v-if="info.level_pic" :visible-arrow="false" effect="light">
                        <div slot="content">
                          <div class="mb-1"><span class="title">黑标：</span>精选邮轮市场畅销产品，一手库存、价格，快速成交，提供有竞争力的佣金，获得更高的回报。</div>
                          <div class="mb-1"><span class="title">金标：</span>覆盖市场大部分需求，实时更新库存，让您时刻了解产品的可售性，保障业务稳定发展。</div>
                          <div class="mb-1"><span class="title">银标：</span>覆盖全球市场多个领域，确保满足不同客户的需求，推动您的业务多元化的发展。</div>
                        </div>
                        <div class="label-icon">
                          <el-image fit="cover" class="label-icon" :src="info.level_pic"></el-image>
                        </div>
                      </el-tooltip>
                      <a :href="href()" target="_blank" class="transition-colors hover:text-primary" :class="{'info-name': info.level_pic}">
                        {{ info.name }}
                      </a>
                    </h2>
                    <slot name="tags" :tags="info.product_tags">
                      <ul class="flex flex-wrap mt-1 mb-2 h-6 overflow-hidden">
                        <li
                            class="inline-flex items-center px-1 rounded-sm text-xxs mr-2 mb-2 h-5"
                            v-for="(item, index) in info.product_tags"
                            :key="index"
                            :class="[ index === 0 ? {
                                  'bg-orange text-white': Number(info.cruise_product_type) === 2,
                                  'bg-purple text-white': Number(info.cruise_product_type) === 1
                              } : 'border border-[#7378E6] text-[#7378E6]']"
                        >{{ item }}</li>
                      </ul>
                    </slot>

                    <slot name="info1">
                        <div class="info items-center">
                            <!-- <div class="info-title">
                            </div> -->
                            <span class="ficon ficon-ziyuancaigou_chufa in-icon"></span>
                            <div class="ellips">出发：{{ info.departure }}</div>
                        </div>
                    </slot>
                    <slot name="info2">
                        <div class="info" v-if="info.ports && info.ports.length">
                            <!-- <div class="info-title">
                            </div> -->
                            <span class="ficon ficon-ziyuancaigou_denglugangkou in-icon"></span>
                            <!-- <div class="ellips">途径：{{ info.ports && info.ports.join(',') }}</div> -->
                            <VEllipsis class="info-text w-[455px]" :rows="1" symbol="查看行程" :expandable="false" suffix="">途径：{{ info.ports.join(',') }}
                                <template #suffix>
                                    <button v-show="showDate?.split('、').length >=6" class="text-highlight ml-1" type="button" @click="$emit('view-trip')">查看更多</button>
                            </template>
                            </VEllipsis>
                        </div>
                    </slot>
                    <slot name="info3">
                        <div class="info" v-if="info.product_date && info.product_date.length">
                            <span class="ficon ficon-ziyuancaigou_chufariqi in-icon"></span>
                            <VEllipsis class="info-text w-[455px]" :rows="1" symbol="查看更多" :expandable="false" suffix="">出游日期：{{ showDate }}
                                <template #suffix>
                                    <button v-show="showDate?.split('、').length >=6" class="text-highlight ml-1" type="button" @click="$emit('view-date')">查看更多</button>
                            </template>
                            </VEllipsis>
                        </div>
                    </slot>
                </div>
                <div class="extra">
                    <el-image fit="cover" class="logo" :src="info.company_logo_url"></el-image>
                    <div class="company">{{ info.company_name }}</div>
                    <div class="absolute right-0 b-8 price-div">
                        <div class="absolute right-0 bottom-full">
                            <div class="price1" v-if="isDistributor">零售价：<span class="text-sm">{{ info.currency_label
                            }}</span><span class="text-lg">{{ info.min_sale_price | toThousandFilter }}</span> 起/人
                            </div>
                            <div class="price2" v-if="isDistributor">同行价：<span class="text-sm">{{ info.currency_label
                            }}</span><span class="text-2xl">{{ info.min_th_price | toThousandFilter }}</span> 起/人
                            </div>
                            <div class="price2" v-else><span class="text-sm">{{ info.currency_label }}</span><span
                                    class="text-2xl">{{ info.min_sale_price | toThousandFilter }}</span> 起/人</div>
                        </div>
                        <!-- <el-button class="f-btn" type="primary" @click="navigateToDetail">查看详情</el-button> -->
                        <div>
                            <el-button class="f-btn" v-if="!isInShop && isDistributor && isOpenShop"
                                icon="ficon ficon-dianpuguanlishuju ml-1" @click="onJoinShop">
                                加入店铺</el-button>

                            <el-button v-if="isDistributor" class="f-btn" icon="ficon ficon-xingzhuangjiehe2 ml-1"
                                @click="handleShareShopPrdouct">
                                分享产品</el-button>
                            <el-button class="f-btn w-35" type="primary" @click="navigateToDetail">查看详情</el-button>
                        </div>
                    </div>
                </div>
                <share-shop-product ref="shareShopProduct"></share-shop-product>
            </div>
        </template>
    </el-skeleton>
</template>
<script>
import { addFavorites, cancelFavorites } from "~/services/product";
import { REQUEST_CODES } from "@/constants/const-http";
import { ProductTypes } from "@/constants/productType";
import { productDetailLink } from "@/utils/product";
import VEllipsis from '~/components/VEllipsis/index.vue'
import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";

import useProductFavorite from '~/views/product/composables/useProductFavorite';
import useProductJoinShop from '~/views/product/composables/useProductJoinShop'
import { defineComponent, ref, useContext, computed } from '@nuxtjs/composition-api';

export default defineComponent({
    props: {
        info: {},
        loading: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ShareShopProduct,
        VEllipsis
    },
    setup(props) {

        // ======================= 分享 =======================
        const shareShopProduct = ref();
        const handleShareShopPrdouct = () => {
            shareShopProduct.value.handleShareShopPrdouct(props.info);
        }
        // ======================= 加入店铺 =======================
        const { store } = useContext();
        const isDistributor = computed(() => store.getters.isDistributor);
        const isAdmin = computed(() => store.getters.isAdmin)
        const isOpenShop = computed(() => store.getters.isOpenShop)
        const loggedIn = computed(() => store.getters.loggedIn)

        // ======================= 收藏 =======================
        const { isFavorite, onToggleFavorite } = useProductFavorite(props.info.product_no)
        isFavorite.value = !!props.info.is_favorite;

        const {
            isInShop,
            onJoinShop,
            updateJoinShopStatus
        } = useProductJoinShop(computed(() => props.info.product_no));
        updateJoinShopStatus(props.info.in_shop)
        return {

            shareShopProduct,
            handleShareShopPrdouct,

            isFavorite, onToggleFavorite,

            isAdmin,
            isOpenShop,
            loggedIn,
            isInShop,
            onJoinShop,

        }
    },
    // data() {
    //     return {
    //         is_favorite: this.info && this.info.is_favorite,
    //     }
    // },
    methods: {
        // async onToggleFavorite(){ //收藏/取消收藏
        //     if (this.is_favorite) {
        //         const { code, msg } = await cancelFavorites(
        //             this.info.product_no
        //         );
        //         if (code !== REQUEST_CODES.ERROR_OK) {
        //             this.$message.error(msg);
        //             throw new Error(msg);
        //         }
        //         this.is_favorite = 0
        //         this.$message.success("取消收藏成功");
        //     } else {
        //         const { code, msg } = await addFavorites(
        //             this.info.product_no
        //         );
        //         if (code !== REQUEST_CODES.ERROR_OK) {
        //             this.$message.error(msg);
        //             throw new Error(msg);
        //         }
        //         this.is_favorite = 1
        //         this.$message.success("收藏成功");
        //     }
        // },
        href() {
            if (this.info.is_tripartite_product === "1") { //单船票产品
                return `/product/automation/${this.info.product_no}`
            }
            return productDetailLink(ProductTypes.CRUISE, this.info.product_no);
        },
        navigateToDetail() {
            window.open(this.href(), '_blank')
        },
    },
    computed: {
        auth() {
            return this.$auth.$state;
        },
        // loggedIn() {
        //     return this.auth.loggedIn;
        // },
        isDistributor() {
            if (!this.auth.loggedIn) return false;
            return !!this.auth.user.distributor;
        },
        showDate() {
            if (Array.isArray(this.info.product_date)) {
                return this.info.product_date.join('、')
            }
            return this.info.product_date
        }
    }
})
</script>

<style lang="scss" scoped>
.goods {
  padding: 28px;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
}
.goods .poster-div {
  height: 180px;
  width: 300px;
}
.goods .poster {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.goods .collect-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 40px;
  cursor: pointer;
}
.goods .detail {
  padding-left: 28px;
  padding-bottom: 52px;
  flex: 1;
}
.goods .detail .name {
  font-size: 20px;
  font-weight: 500;
  padding-right: 120px;
  display: flex;
  position: relative;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.goods .detail .info {
  font-size: 16px;
  margin-bottom: 8px;
  padding-right: 120px;
  line-height: 24px;
  display: flex;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.goods .detail .info .ellips {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goods .detail .info .in-icon {
  margin-right: 12px;
  font-size: 20px;
}
.goods .detail .info .info-title {
  white-space: nowrap;
  display: flex;
}
.goods .detail .info .btn-more {
  padding: 0;
  font-size: 16px;
  margin-left: 4px;
}
.goods .detail .info .holiday-tag {
  display: inline-block;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  font-size: 13px;
  color: #fff;
  text-align: center;
  background: linear-gradient(90deg, #F2007D 0%, #F2B203 100%);
  border-radius: 11px 2px 11px 11px;
  margin-left: 8px;
}
.goods .detail .info-name {
  text-indent: 28px;
  margin-left: -26px;
}
.goods .detail .label-icon {
  height: 28px;
  width: 28px;
  margin-left: -1px;
}
.goods .extra {
  text-align: right;
  white-space: nowrap;
  position: relative;
}
.goods .extra .logo {
  width: 104px;
  height: 36px;
  border-radius: 4px;
  margin-bottom: 4px;
  margin-top: -8px;
  border: 1px solid #979AA8;
}
.goods .extra .company {
  font-size: 14px;
  line-height: 1;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.goods .extra .f-btn {
  border-radius: 0.25rem;
}
.goods .extra :deep(.el-button--default):hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.goods .extra :deep(.el-button--default):focus {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.goods .extra :deep(.el-button--default) {
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.goods .extra .b-8 {
  bottom: -8px;
}
.goods .extra .price1 {
  font-size: 14px;
  color: #606060;
  line-height: 1;
}
.goods .extra .price1 span {
  color: $color-black-2;
  font-weight: 500;
}
.goods .extra .price2 {
  font-size: 16px;
  color: #606060;
  line-height: 1;
  margin-bottom: 8px;
}
.goods .extra .price2 span {
  --tw-text-opacity: 1;
  color: rgba(204, 75, 12, var(--tw-text-opacity));
  font-weight: 500;
}
.title {
  font-weight: 500;
}
</style>
<style lang="scss">

.popper-class-tooltip {
  border: 1px solid #D4D7DE !important;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1) !important;
  width: 248px !important;
  color: #1F2129;
  padding: 8px 10px 6px;
  margin-top: 2px !important;
  text-align: justify;
}

</style>
